import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueRouter from 'vue-router';
import store from '../store/';
// import chatRoutes from './laravel-video-chat';
import formbuilderRoutes from './formbuilder';
import clinicRoute from './clinics';
import dictionaryRoutes from './dictionary';

import Homepage from '../layouts/homepage';
import MainPage from '../views/Index';
import GuestPage from '../layouts/guest-page';
import Security from '../views/auth/security';
import Lock from '../views/auth/lock';
import ProfilePage from '../views/ProfilePage';
import Contacts from '../views/Contacts.vue';
import RecordsPage from '../views/RecordsPage';
import CustomPage from '../views/CustomSite/CustomPage';
import News from '../views/CustomSite/News';
import CurrentNews from '../views/CustomSite/CurrentNews';
import Uslugi from '../views/CustomSite/Uslugi';
import Specialists from '../views/CustomSite/Specialists';
import CurrentSpecialist from '../views/CustomSite/CurrentSpecialist';
import Standards from '../views/CustomSite/Standards';
import Documents from '../views/CustomSite/Documents';
import Reviews from '../views/CustomSite/Reviews';
import CustomContacts from '../views/CustomSite/Contacts';
import PoliticsPage from '../views/PoliticsPage';

import Login from '../views/auth/login';
import Password from '../views/auth/password';
import Register from '../views/auth/register';
import Activate from '../views/auth/activate';
import Reset from '../views/auth/reset';
import SocialAuth from '../views/auth/social-auth';

import ErrorPage from '../layouts/error-page';
import IPRestricted from '../views/errors/ip-restricted';
import Maintenance from '../views/errors/maintenance';
import PageNotFound from '../views/errors/page-not-found';
import Template from '@app/layouts/main/Index';
import List from '../views/clinics/pages/List';

import AccessDenied from '../views/AccessDenied';

import { http, organizationApi, adminApi } from '@app/services';
import TestPage from '@app/views/TestPage';
import SimpleLanding from '@app/views/simple-landing';

Vue.use(Loading);

const routes = [
  {
    path: '/',
    meta: { validate: ['two_factor', 'lock_screen'] },
    component: Template,
    children: [
      {
        path: '',
        name: 'main',
        component: MainPage
      },
      {
        path: 'nextchat/:id',
        component: () => import('@app/views/video-chat/Index'),
      },
      {
        path: 'chat',
        component: () => import('@app/views/vuex-chat/chat-room/Index'),
        children: [
          {
            path: '',
            name: 'vuexchat',
            component: () => import('@app/views/vuex-chat/chat-room/Main'),
          },
          {
            path: ':id',
            name: 'vuexchatroom',
            component: () => import('@app/views/vuex-chat/chat-room/Conversation'),
          },
        ]
      },
      // ...chatRoutes,
      ...formbuilderRoutes,
      {
        path: 'registry',
        redirect: { name: 'registry.main', params: { clinicName: 'demo' } }
      },
      {
        path: 'appointment',
        redirect: { name: 'appointment.make', params: { clinicName: 'demo' } }
      },
      dictionaryRoutes
    ]
  },
  {
    path: '/video-appointment/:id',
    name: 'video.appointment',
    component: () => import('@app/views/simple-landing/video-appointment/index'),
  },
  {
    path: '/clinics/:clinicName',
    name: 'clinic.public',
    component: SimpleLanding
  },
  {
    path: '/',
    component: Template,
    children: [
      {
        path: '/register',
        component: Register,
        name: 'index.register'
      },
      {
        path: 'clinics',
        name: 'clinic.list',
        validate: ['two_factor', 'lock_screen'],
        component: List
      },
      {
        path: '/profilepage',
        component: ProfilePage,
        name: 'index.profilepage'
      },
      {
        path: '/contacts',
        component: Contacts,
        name: 'contacts'
      },
      {
        path: '/politics',
        component: PoliticsPage,
        name: 'politics'
      },
      {
        path: '/records',
        component: RecordsPage,
        name: 'index.recordspage'
      },
      clinicRoute
    ]
  },
  {
    path: '/',
    meta: { validate: ['two_factor', 'lock_screen'] },
    component: CustomPage,
    name: 'custom-page',
    children: [
      {
        path: '/news',
        component: News,
        name: 'news',
        children: [
          {
            path: ':id',
            component: CurrentNews,
            name: 'current-news'
          }
        ]
      },
      {
        path: '/patients',
        component: Uslugi,
        name: 'patients',
      },
      {
        path: '/specialists',
        component: Specialists,
        name: 'specialists'
      },
      {
        path: '/specialists/:id',
        component: CurrentSpecialist,
        name: 'currentSpecialist'
      },
      {
        path: '/standards',
        component: Standards,
        name: 'standards'
      },
      {
        path: '/documents',
        component: Documents,
        name: 'documents'
      },
      {
        path: '/reviews',
        component: Reviews,
        name: 'reviews'
      },
      {
        path: '/contact',
        component: CustomContacts,
        name: 'contact'
      }
    ]
  },
      {
        path: '**',
        redirect: { name: store.state.navigation.site ? 'custom-page' : 'main' }, 
      },
  {
    path: '/auth',
    component: GuestPage,
    meta: { validate: ['auth'] },
    children: [
      {
        path: 'security',
        component: Security
      },
      {
        path: 'lock',
        component: Lock
      }
    ]
  },
  {
    // all the routes which can be access without authentication
    path: '/',
    component: GuestPage,
    meta: { validate: ['guest'] },
    children: [
      {
        path: '/',
        component: Homepage,
        children: [{ path: '', component: MainPage, name: 'index.login' }]
      },
      {
        path: '/login',
        component: Login
      },
      {
        path: '/password',
        component: Password
      },
      {
        path: '/register',
        component: Register,
        name: 'index.register'
      },
      {
        path: '/auth/:token/activate',
        component: Activate
      },
      {
        path: '/password/reset/:token',
        component: Reset
      },
      {
        path: '/auth/social',
        component: SocialAuth
      }
    ]
  },
  {
    path: '/',
    component: ErrorPage,
    children: [
      {
        path: '/ip-restricted',
        component: IPRestricted
      },
      {
        path: '/maintenance',
        component: Maintenance
      }
    ]
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: AccessDenied
  },
  {
    path: '/404',
    name: 'page-not-found',
    component: PageNotFound
  },
  {
    path: '*',
    component: ErrorPage,
    children: [
      {
        path: '*',
        component: PageNotFound
      }
    ]
  }
];

const router = new VueRouter({
  routes,
  // linkActiveClass: 'active',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});

async function clinicResolve(to) {
  const { clinicName } = to.params;
  if (typeof clinicName === 'undefined') {
    return false;
  }
  const uuidReg = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const slugReg = /^[a-z](-?[a-z])*$/;
  if (uuidReg.test(clinicName)) {
    const hasUuid = http.apiKeys.findIndex(k => k[0] === clinicName) > -1;
    if (hasUuid) {
      http.setApiKey(clinicName);
      return clinicName;
    }
    try {
      const response = await organizationApi.getByUuid(clinicName);
      http.setApiKey(clinicName);
      http.apiKeys.push([clinicName, response.slug]);
      return clinicName;
    } catch (e) {
      return false;
    }
  } else if (slugReg.test(clinicName)) {
    const apiKey = http.apiKeys.find(k => k[1] === clinicName);
    if (apiKey) {
      http.setApiKey(apiKey[0]);
      return apiKey[0];
    }
    try {
      if (!store.state.auth.is_auth) {
        http.removeToken();
      }
      const response = await organizationApi.getBySlug(clinicName);
      http.setApiKey(response.id);
      http.apiKeys.push([response.id, response.slug]);
      return response.id;
    } catch (e) {
      return false;
    }
  }
  return false;
}

function clinicGuard(uuid, to) {
  const { resources } = store.state.permission;
  console.log(resources);
  const resourceRoles =
    typeof resources === 'undefined' ||
    resources === null ||
    typeof resources.organization === 'undefined' ||
    typeof resources.organization[uuid] === 'undefined'
      ? []
      : resources.organization[uuid].roles;
  return (
    [...to.matched].reverse().findIndex(route => {
      if (
        typeof route.meta === 'undefined' ||
        typeof route.meta.resources === 'undefined' ||
        route.meta.resources.findIndex(r => r.type === 'organization') === -1
      ) {
        return false;
      }
      const resource = route.meta.resources.find(
        r => r.type === 'organization'
      );
      if (typeof resource === 'undefined') {
        return false;
      }
      const { roles } = resource;
      if (typeof roles === 'undefined' || roles.length === 0) {
        return false;
      }
      return !(roles.findIndex(role => resourceRoles.indexOf(role) > -1) > -1);
    }) === -1
  );
}

router.beforeEach(async (to, from, next) => { 
  console.log(window.location.origin, process.env.VUE_APP_API_URL);
  
  // Инициализация пользователя
  const token = localStorage.getItem('auth_token');
  if (token) {
    if (store.state.auth.is_auth) {
      console.log('you already have config');
    } else {
      await helper.check();
      await store.dispatch('permission/loadPermissions');
    }
  }
  if(to.query.redirect_url || to.query.state) {
    const urlParams = new URLSearchParams(to.hash);
    const acc_tok = urlParams.get('#access_token');
    const secterKey = urlParams.get('session_secret_key');
    const insta = to.query.state;
    if (acc_tok && secterKey) {
      router.push({path: to.query.redirect_url, hash: `access_token=${acc_tok ? acc_tok : ''}&session_secret_key=${secterKey}`});
    } else if (to.query.state) {
      router.push({path: to.query.state, query: { code: to.query.code ? to.query.code: ''}, hash: '#_'});
    } else {
      router.push({path: to.query.redirect_url, hash: `access_token=${acc_tok}&token_type=${ urlParams.get('token_type')}`});
    }
  }
  if (!to.query.redirect_url && window.location.origin !== process.env.VUE_APP_API_URL && !store.state.navigation.site) {
    if(!store.state.auth.is_auth) {
      http.removeToken();
    } 
    try {
    const myClinic = await organizationApi.websiteGet({website: window.location.host});
    if (myClinic) {
      store.commit('navigation/show');
      http.setApiKey(myClinic.id);
      await store.dispatch('clinic/loadOrganization');
      document.title = myClinic.title;
      const link = document.querySelector('link[rel*="icon"]');
      link.href = myClinic.front.header.favicon;
      await store.commit('clinic/setUuid', myClinic.id);
      store.commit('navigation/setSite', window.location.host);
      store.commit('navigation/hide');
    }
    } catch {
    }
  }
  // Загрузка мультиязычности
  // if (!window.i18n) {
  //   try {
  //     const lang = await axios.get('/api/lang');
  //     window.i18n = lang.data.ru;
  //   }
  //   catch (e) {
  //     console.log(e);
  //   }
  // }
  // Проверка существавании клиники
  if (to.matched[0].name === 'clinic.public' ||
    (to.matched.length > 2 && to.matched[1].path === '/clinics')) {
    const uuid = await clinicResolve(to);
    store.commit('clinic/setUuid', uuid);
    if (!uuid) {
      next({ name: 'page-not-found' });
    } else {
      const hasPermission = clinicGuard(uuid, to);
      if (hasPermission) {
        next();
      } else {
        next({ name: 'access-denied' });
      }
    }
  } else {
    next();
  }
});

export default router;
